import client from '../client';
import * as cargoPortMutations from "../mutations/cargoPort";

export function add(success, error, data) {
    client.mutate({
        variables: { cargoPort: data },
        mutation: cargoPortMutations.add,
    }).then(success).catch(error);;
}


export function edit(success, error, id, data) {
    client.mutate({
        variables: { id: id, cargoPort: data },
        mutation: cargoPortMutations.edit,
    }).then(success).catch(error);
}


// WEBPACK FOOTER //
// ./src/graphql/actions/cargoPort.js